import { render, staticRenderFns } from "./BundleRecommendation.vue?vue&type=template&id=8e6f6d0a&scoped=true&"
import script from "./BundleRecommendation.vue?vue&type=script&lang=ts&"
export * from "./BundleRecommendation.vue?vue&type=script&lang=ts&"
import style0 from "./BundleRecommendation.vue?vue&type=style&index=0&id=8e6f6d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6f6d0a",
  null
  
)

export default component.exports